import { type AxiosResponse } from 'axios'
import api from '../utils/api'

const getTaskById = async (taskId: string): Promise<AxiosResponse> => {
  return await api.get(`/api/tasks/${taskId}/`)
}

/**
 * Stop a background task (CR-284).
 *
 * The backend writes `status=REVOKED` / `result=WARNING` with an `end_timestamp`, then
 * revokes the Celery task with `terminate=True`. Requires `TaskMonitor.EDIT` and
 * ownership of the task (or a global role), so a caller who can list tasks but not edit
 * them gets a 403.
 */
const revokeTask = async (taskId: string): Promise<AxiosResponse> => {
  return await api.post(`/api/tasks/revoke/${taskId}/`)
}

export {
  getTaskById,
  revokeTask
}
